/**
 * Group names are stored with a trailing underscore by convention (e.g.
 * "leader_", "super_admin_" — see src/utils/adminGroup.ts). Display-only:
 * never use this for comparisons or API calls, only for what's shown.
 */
export const prettifyGroup = (name: string | null | undefined): string =>
  (name || '')
    .replace(/_$/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
